import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import StudyGoal from "./StudyGoal";
import { selectStudyGoalByProps } from "../../selectors/studyGoalSelectors";
import { getCurrentCourseUser } from "../../selectors/coursesUserSelectors";
import { getCurrentCourseId } from "../../selectors/courseSelectors";
import { fetchStudyGoal } from "../../processes/studyGoalProcesses";
import { selectStudyPlanDaysCount, selectStudyPlanCompletionDate } from "../../selectors/studyPlanSelectors";
import { currentCourse } from "../../selectors/courseSelectors";
import { weekdays } from "../../utils/findDateByTargetWeekdays";
import { isToday } from "../../utils/isToday";

const getTodayStudiedTimeSeconds = (studyGoal) => {
  const weekdayStudyGoals = studyGoal?.weekdayStudyGoalsAttributes;

  const today = new Date();
  const currentWeekdayStudyGoal = weekdayStudyGoals?.find(
    (weekdayStudyGoal) => weekdayStudyGoal.weekday === weekdays[today.getDay()],
  );

  const currentDayStudyGoal =
    currentWeekdayStudyGoal?.dayStudyGoalsAttributes?.find((dayStudyGoal) =>
      isToday(dayStudyGoal?.createdAt),
    );

  const studiedTimeSecondsList =
    currentDayStudyGoal?.dayStudyGoalsLessonAttributes?.map(
      (dayStudyGoalsLesson) => dayStudyGoalsLesson.studiedTimeSeconds,
    ) || [];

  const todayStudiedTimeSeconds = studiedTimeSecondsList?.reduce(
    (a, b) => a + b,
    0,
  );

  return todayStudiedTimeSeconds;
};

function StudyGoalContainer(props) {
  const { dispatch, studyGoal } = props;

  useEffect(() => {
    if (studyGoal?.id) {
      fetchStudyGoal(dispatch, studyGoal?.id);
    }
  }, [dispatch, studyGoal?.id]);

  const studyGoalStats = useMemo(() => {
    const todayStudiedTimeSeconds = getTodayStudiedTimeSeconds(studyGoal);

    const studyGoalProgress =
      (todayStudiedTimeSeconds * 100) / studyGoal?.dayStudyDurationSeconds;

    return { todayStudiedTimeSeconds, studyGoalProgress };
  }, [studyGoal]);

  return (
    <StudyGoal
      {...studyGoalStats}
      {...props}
    />
  );
}

const mapStateToProps = (state) => {
  const coursesUser = getCurrentCourseUser(state);
  const course = currentCourse(state);

  return {
    coursesUser,
    course,
    courseId: getCurrentCourseId(state),
    studyGoal: selectStudyGoalByProps(state, {
      coursesUserId: coursesUser?.id,
    }),
    studyDaysCount: selectStudyPlanDaysCount(state),
    completionDate: selectStudyPlanCompletionDate(state),
  };
};

export default connect(mapStateToProps)(StudyGoalContainer);
